import { useSoundEffect } from 'src/hooks/useSoundEffect'

type Props = Readonly<{
  href?: string
  children: React.ReactNode
  className?: string
  label?: string
  target?: string
}>

export function ExternalLink({ href, children, className, label, target = '_top' }: Props) {
  const { playEffect } = useSoundEffect()
  return (
    <a
      className={`button ${className}`}
      href={href}
      onClick={(e) => {
        // If href is not defined, prevent default action
        if (!href) {
          e.preventDefault()
          return
        }

        playEffect('click')
      }}
      rel="noreferrer"
      target={target}
    >
      {label ? <span className="label">{label}</span> : null}
      {children}
    </a>
  )
}
